export { default } from './ExpansionPanel';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ExpansionPanel/index.js
// module id = 540
// module chunks = 2